<script lang="ts" setup>
import { useDate } from "@/composables/date";
import { computed, ref } from "vue";
import BaseContent from "./BaseContent.vue";

const props = defineProps<{
    character: Character;
}>();

const releasedAt = useDate(props.character.released_at);
const ezas = ref<Array<object>>(
    props.character.awakenings.filter((e) => e.type === "Extreme Z"),
);
const ezaAt = computed(() =>
    ezas.value.length > 0 ? useDate(ezas.value[0].released_at) : null,
);
const sezaAt = computed(() =>
    ezas.value.length > 0 && ezas.value[ezas.value.length - 1].eza_type === 2
        ? useDate(ezas.value[ezas.value.length - 1].released_at)
        : null,
);
</script>

<template>
    <div
        class="-m-4 mt-0 grid grid-cols-2 gap-2 border-t border-green-900/75 p-4 sm:grid-cols-3 lg:grid-cols-2"
    >
        <BaseContent header="Release Date">
            <span
                >{{ releasedAt.format("PP") }} <br />
                <span class="text-sm">{{
                    releasedAt.format("p O")
                }}</span></span
            >
        </BaseContent>

        <BaseContent v-if="ezaAt" header="EZA Date">
            <span
                >{{ ezaAt.format("PP") }} <br />
                <span class="text-sm">{{ ezaAt.format("p O") }}</span></span
            >
        </BaseContent>

        <BaseContent
            v-if="ezas.length > 0 && ezas[ezas.length - 1].eza_type === 2"
            class="col-start-2 sm:col-start-auto lg:col-start-2"
            header="SEZA Date"
        >
            <span
                >{{ sezaAt.format("PP") }}<br />
                <span class="text-sm">{{ sezaAt.format("p O") }}</span></span
            >
        </BaseContent>
    </div>
</template>

<style scoped></style>
